<ldw-web-doku-list-view
  [data]="webDokus"
  (itemSelected)="onWebDokuSelected($event)">
</ldw-web-doku-list-view>

